import { render } from "./ServicesView.vue?vue&type=template&id=3983b162&scoped=true"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=3983b162&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ASUS\\Documents\\PROFESSIONNEL\\DVPT-WEB\\pierre-hydraulic\\phs-website-Vuejs-V1.1.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3983b162"]])

export default __exports__